import { render, staticRenderFns } from "./BusinessCardResult.vue?vue&type=template&id=61d02f13&scoped=true&"
import script from "./BusinessCardResult.vue?vue&type=script&lang=js&"
export * from "./BusinessCardResult.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCardResult.vue?vue&type=style&index=0&id=61d02f13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d02f13",
  null
  
)

export default component.exports